import { Dispatch, SetStateAction, useCallback, useMemo, useState } from 'react';
import { useInterval } from 'usehooks-ts';
import { MAX_RETRIES, THIRTY_SECONDS } from '@/constants/polling';
import { createPlaybackToken } from '@/server/services/blendvision';
import { getVod } from '@/services/blendvision';
import { Asset } from '@/types/asset';
export const usePollBlendVisionVodStatus = (assets: Asset[], setAssets: Dispatch<SetStateAction<Asset[]>>, profile: 'public' | 'private') => {
  const [retryCount, setRetryCount] = useState(0);
  const [stopInterval, pendingVodAssets] = useMemo(() => [assets.length <= 0 || assets.every(asset => asset.image?.url || asset.video?.isConverted && (profile === 'private' || Boolean(asset.video.playbackToken))) || retryCount >= MAX_RETRIES, assets.filter(asset_0 => asset_0.video && asset_0.video.vodId && (!asset_0.video.isConverted || profile === 'public' && !asset_0.video.playbackToken))], [assets, profile, retryCount]);
  const handleCheckVodStatus = useCallback(async () => {
    if (pendingVodAssets.length === 0) return;
    setRetryCount(prev => prev + 1);
    const promises = pendingVodAssets.map(async asset_1 => {
      const vodResponse = await getVod(asset_1.video!.vodId);
      if (!('vod' in vodResponse)) {
        return;
      }
      const vod = vodResponse.vod;
      if (vod.status !== 'VOD_STATUS_SUCCEEDED') {
        return;
      }
      const coverImage = vod.cover_image?.auto.url;
      if (profile === 'public') {
        const playbackToken = await createPlaybackToken({
          resourceId: asset_1.video!.vodId,
          resourceType: 'RESOURCE_TYPE_VOD_EVENT'
        });
        if (!playbackToken) return;
        const {
          token
        } = playbackToken;
        setAssets(prev_0 => prev_0.map(a => a.video?.vodId === asset_1.video?.vodId ? {
          ...a,
          video: {
            ...a.video!,
            ...(coverImage && {
              coverImage
            }),
            playbackToken: token,
            isConverted: true
          }
        } : a));
      } else {
        setAssets(prev_1 => prev_1.map(a_0 => a_0.video?.vodId === asset_1.video?.vodId ? {
          ...a_0,
          video: {
            ...a_0.video!,
            ...(coverImage && {
              coverImage
            }),
            isConverted: true
          }
        } : a_0));
      }
    });
    await Promise.all(promises);
  }, [pendingVodAssets, setAssets, profile]);
  useInterval(handleCheckVodStatus, stopInterval ? null : THIRTY_SECONDS);
};